<template>
    <div>
        <CRow>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>نوتیفیکیشن</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                            hover
                            striped
                            :items="items"
                            :fields="fields"
                            :items-per-page="10"
                            :active-page="active_page"
                            :pagination="{ doubleArrows: false, align: 'center'}"
                            :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
                        >
                            <template #log_type="data">
                                <td><CBadge :color="get_badge(data.item.log_type)">{{data.item.log_type}}</CBadge></td>
                            </template>
                            <template #from_name="data">
                                <td v-if="data.item.from_id==0">{{data.item.from_name}}</td>
                                <td v-else>
                                    <router-link :to="`/profile/${data.item.from_id}`">
                                        {{data.item.from_name}}
                                    </router-link>
                                </td>
                            </template>
                            <template #to_name="data">
                                <td v-if="data.item.to_id==0">{{data.item.to_name}}</td>
                                <td v-else>
                                    <router-link :to="`/profile/${data.item.to_id}`">
                                        {{data.item.to_name}}
                                    </router-link>
                                </td>
                            </template>
                            <template #log_details="data">
                            <td>
                                <template>
                                <div class="flex-container">
                                    <div @click="log_details=data.item.log_info;log_modal=true"
                                        v-c-tooltip.hover="'جزییات'">
                                        <CIcon name="cilListRich" size="lg"/>
                                    </div>
                                </div>
                                </template>
                            </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
			title="جزییات لاگ"
			size="xl"
			color="primary"
			:show.sync="log_modal"
			>
            <pre style="text-align:left;direction:ltr;">{{ JSON.stringify(this.log_details, null, '\t') }}</pre>
			<template #footer>
				<CButton @click="log_modal=false" color="primary">بستن</CButton>
			</template>
		</CModal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [],
            fields: [
                { key: 'from_name', label: 'از کاربر' },
                { key: 'to_name', label: 'به کاربر' },
                { key: 'ip', label: 'IP' },
                { key: 'log_type', label: 'نوع لاگ' },
                { key: 'created_at', label: 'تاریخ' },
                { key: 'log_details', label: 'عملیات' },
            ],
            active_page: 1,
            log_modal: false,
            log_details: [],
        }
    },
    watch:{
        '$store.state.notifications':{
            handler(){
                this.items = this.$store.state.notifications;
            }
        },
        '$store.state.alert':{
            handler(){
                this.$store.commit('set_alert', null);
            }
        }
    },
    mounted() {
        this.items = this.$store.state.notifications;
        this.$store.commit('set_alert', null);
    },
    methods:{
        get_badge(status) {
            switch (status) {
                default: return 'secondary';
            }
        },
    },
	beforeCreate(){
		if(this.$store.state.perms.can_view_user_logs_over_ws == false
            && this.$store.state.perms.can_view_same_user_groups_logs_over_ws == false
            && this.$store.state.perms.can_view_all_user_logs_over_ws == false){
			this.$router.push('/403')
		}
	},
}
</script>